import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './DASHBOARD.css';

// 로딩 중에 보여줄 스켈레톤 컴포넌트
const DashboardSkeleton = ({ isLoggedIn }) => {
    const SkeletonCard = () => (
        <div className="dash-product-card">
            <div className="dash-product-image-wrapper">
                <Skeleton height="100%" />
            </div>
            <div className="dash-product-info">
                <Skeleton height={36} style={{ marginBottom: '10px' }} />
                <Skeleton height={20} width="80%" />
            </div>
        </div>
    );

    const SkeletonSection = ({ title, icon }) => (
        <div className="dash-product-section">
            <div className="dash-section-header">
                <h2 className="dash-section-title">
                    {icon && <span className="dash-title-icon">{icon}</span>}
                    {title}
                </h2>
                <button className="dash-more-button">더보기</button>
            </div>
            <div className="dash-products-grid">
                {Array.from({ length: 5 }).map((_, i) => <SkeletonCard key={i} />)}
            </div>
        </div>
    );

    return (
        <SkeletonTheme baseColor="#e9ecef" highlightColor="#f8f9fa">
            <div className="dash-dashboard-content">
                <SkeletonSection title="잉여 재고 거래" icon="📦" />
                <SkeletonSection title="행사 품목" icon="🔥" />
                {isLoggedIn && <SkeletonSection title="자사재고현황" icon="🏢" />}
            </div>
        </SkeletonTheme>
    );
};

export default DashboardSkeleton;
